﻿import React, { useState, useEffect } from 'react';
import { Vendor } from '../../models/TablesManagement/vendor';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';

export interface Props {
    title: string;
}

export default function VendorsTableManagementForm(props: Props) {
    const [vendors, setVendors] =
        useState<Vendor[]>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getVendors();
    }, []);

    const gridWidth = 'calc(90vw - 13em)';

    return (
        <div>
            <DataGrid width={gridWidth}
                height="65vh"
                keyExpr="vendorId"
                dataSource={vendors ? vendors : []}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode='widget'
                onRowValidating={onVendorRowValidating}
                rowAlternationEnabled={true}
                showRowLines={true}
                showBorders={true} >

                <LoadPanel enabled={true} />
                <Paging enabled={false} />
                <Selection mode='single' />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <GroupPanel visible={false} />
                <SearchPanel visible={true} />
                <Scrolling columnRenderingMode='virtual' />

                <Column type="buttons" width={"5rem"}>
                    <ColumnButton name="edit" />
                </Column>

                <Column dataField='name' width='20rem' />
                <Column dataField="active" dataType="boolean" width="8rem" />
                <Column />
                
                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">{props.title}</div>
                        </div>
                    </ToolbarItem>
                    <ToolbarItem name="addRowButton" location='after' />
                    <ToolbarItem name="searchPanel" location='after' />
                </Toolbar>

                <Editing
                    mode="popup"
                    useIcons={true}
                    allowAdding={true}
                    allowUpdating={true}
                    allowDeleting={false} >

                    <Popup title={props.title} showTitle={true} width='80vw' height='80vh' />
                    <Form>
                        <Item dataField="name" colSpan={2} />
                        <Item dataField="active" />
                    </Form>

                </Editing>
            </DataGrid >

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function onVendorRowValidating(e: any) {
        if (e.oldData) {
            let vendor = e.oldData as Vendor;

            if (vendor) {
                let updatedVendor = { ...vendor, ...e.newData };

                await updateVendor(updatedVendor)
                    .then(() => {
                        showToast("Vendor updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Vendor");
                    });
            }
        }
        else {
            if (e.newData) {
                let vendor = e.newData as Vendor;
                
                if (vendor) {
                    vendor.active = true;

                    await insertVendor(vendor)
                        .then(data => {
                            showToast("Vendor saved", "success");
                            getVendors();
                        })
                        .catch(res => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Vendor");
                        });
                }
            }
        }
    }

    async function getVendors() {
        await CrudFunctions.getData("common/vendors")
            .then((data) => {
                setVendors(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Vendors");
            });
    }

    async function insertVendor(vendor: Vendor) {
        return await CrudFunctions.postData("common/vendor", vendor)
    }

    async function updateVendor(vendor: Vendor) {
        return await CrudFunctions.putData("common/vendor", vendor)
    }

    //show/hide

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
